import clsx from 'clsx';
import { Alert02Icon } from 'hugeicons-react';
import PropTypes from 'prop-types';

function FormError({ error, className }) {
  if (!error) return null;
  return (
    <p
      className={clsx(
        'text-sm bg-event-primary text-white text-center p-1 px-2 rounded-lg shadow-md flex items-center justify-center gap-2',
        className,
      )}
    >
      <span>{<Alert02Icon size={18} strokeWidth={2} />}</span>
      <span>{error.message}</span>
    </p>
  );
}

FormError.propTypes = {
  error: PropTypes.object,
};

export default FormError;
